import React, { Component } from 'react';
import moment from 'moment';
import styles from './index.less';

export default class ListItem extends Component {
  renderImg = (coverPicFileUrl, stencilId) => {
    return (
      <div
        className="left-item"
        style={{ margin: stencilId === 1 || stencilId === 5 ? '0 8px 0  0' : '0 0 0 8px' }}
      >
        <img src={coverPicFileUrl} alt="" />
      </div>
    );
  };

  renderDetail = (title, summary, outputDate) => {
    return (
      <div className="right-item">
        <div className="title-name">{title}</div>
        <div className="time">{moment(outputDate).format('YYYY.MM.DD')}</div>
        <div className="summary">{summary}</div>
      </div>
    );
  };

  render() {
    const { className, title, summary, outputDate, coverPicFileUrl, stencilId } = this.props;
    return (
      <div className={`${styles.item} ${styles[className]}`}>
        {stencilId === 1 || stencilId === 5
          ? this.renderImg(coverPicFileUrl, stencilId)
          : this.renderDetail(title, summary, outputDate)}
        {stencilId === 1 || stencilId === 5
          ? this.renderDetail(title, summary, outputDate)
          : this.renderImg(coverPicFileUrl, stencilId)}
      </div>
    );
  }
}
